import type {
    ITourSelectItemViewModel,
    ITourSelectViewModel,
} from '@monofe/ui-workspace/tourselect/interface';
import type { IBaseControllerRenderResult } from '../interface';

export interface IRouteTourSelectArguments {
    db: string;
    languageId: number;
    sessionName: string;
}

export interface ITourSelectControllerProps {
    didRequestTour: (id: number) => void;
    didRequestBack: () => void;
    route: IRouteTourSelectArguments;
}

export interface ITourSelectControllerRenderResult
    extends IBaseControllerRenderResult<{ tourId: number }> {}

export interface ITourSelectItemControllerModel extends ITourSelectItemViewModel {}

export interface ITourSelectControllerModel extends ITourSelectViewModel {}

export enum ITourSelectType {
    Undef = 0,
    List = 1,
    GridTile = 2,
    GridFeatured = 3,
    LastValue = 4,
}
